/**
 * Collections script
 */
import utils from '../utils';
import Vue from 'vue/dist/vue';
import ui from "../ui";

require('./vue/select2');

/**
 * Ensure the collection is always of size n + 1 so new items can easily be added
 */
const updateCollectionSize = function(vm) {
    // Skip if we are not supposed to keep an empty n+1
    if (!Array.isArray(vm.collection)) {
        return;
    }

    let collection = vm.collection;

    // Purge empty items if configured
    if (vm.purgeEmpty) {
        // We purge backwards to prevent index mismatches
        for (let i = collection.length - (vm.nPlusOne ? 2 : 1); i >= 0; i--) {
            if (i < 0) {
                continue;
            }
            let item = collection[i];
            if (vm.type === 'object' ? Object.keys(item).length === 0 : item.length === 0) {
                collection.splice(i, 1);
            }
        }
    }

    // Add a last item
    if (vm.nPlusOne) {
        let lastItem         = collection.length > 0 ? collection[collection.length - 1] : null;
        let needsOneMoreItem = lastItem === null || (vm.type === 'object' ? Object.keys(lastItem).length > 0 : lastItem.toString().length > 0);
        if (needsOneMoreItem) {
            collection.push(vm.type === 'object' ? {} : '');
        }
    }

    vm.collection = collection;
};

/**
 * Load options from the var
 */
const loadOptionsData = function() {
    let loaded    = [];
    let mirror    = $('.mfp-content').find('.CodeMirror').get(0).CodeMirror;
    this.loadData = mirror.getDoc().getValue();
    this.loadData.split("\n").forEach(function(item) {
        let explodedItem = item.split(";");
        if (explodedItem.length === 0) {
            return;
        }
        loaded.push({
            value: explodedItem[0],
            label: explodedItem.length > 1 ? explodedItem[1] : explodedItem[0],
        });
    });
    this.collection = loaded;
};

/**
 * Load options from the var
 */
const unloadOptionsData = function() {
    let unloaded = [];
    this.collection.forEach(function(item) {
        if (item.value === undefined || item.value.length === 0) {
            return;
        }
        unloaded.push(item.value === item.label ? item.value : `${item.value};${item.label}`);
    });
    this.loadData = unloaded.join("\n");
    let mirror    = $(this.$el).find('.CodeMirror').get(0).CodeMirror;
    mirror.getDoc().setValue(this.loadData);
    mirror.refresh();
};

/**
 * Used for the order settings product widget
 *
 * Get options for an enum field
 */
const getOptions = function(product, fieldOptions) {
    let options = fieldOptions.find(function(option) {
        return option.id == product.id;
    });
    if (options && options.options) {
        options = options.options;
        if (!product.values) {
            product.values = {};
        }
        // Make sure product has values
        options.forEach(function(option) {
            if (product.values[option.value] === undefined) {
                product.values[option.value] = {};
            }
        });
        return options;
    } else {
        product.values = null;
    }
    return null;
};

/**
 * Returns if the chosen product is an enum field when true
 */
const isProductField = function(product, fieldOptions) {
    return fieldOptions.some(function(option) {
        return option.id == product.id;
    });
};

/**
 * Initialization of VM for all campaign fields related script
 * inside a container
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    $container.find('[data-collection]').each(function() {
        let $collection = $(this);
        if ($collection.hasClass('initialized')) {
            return;
        }

        let defaults = {
            collection:    [],
            nPlusOne:      false,
            purgeEmpty:    false,
            type:          'object',
            selectName:    null,
            selectOptions: [],
        };

        let id = utils.uniqueID($collection);

        // Update the template to bind
        utils.vueBind($collection.find('[id], [name], [for]'), ['id', 'name', 'for']);

        let vm = new Vue({
            el:      `#${id}`,
            data:    $.extend(defaults, $collection.data('collection')),
            methods: {
                loadOptionsData:   loadOptionsData,
                unloadOptionsData: unloadOptionsData,
                isProductField:    isProductField,
                getOptions:        getOptions,
            },
            mounted: function() {
                updateCollectionSize(this);
                let $element = $(this.$el);
                ui.initializeContainer($element);
            },
            updated: function() {
                let $element = $(this.$el);
                ui.initializeContainer($element);
                $('body').find('[data-match-height]').matchHeight();
            },
            watch:   {
                collection: {
                    handler: function() {
                        updateCollectionSize(this);
                    },
                    deep:    true,
                },
            },
        });

        $collection.addClass('initialized').data('vm', vm);
    });
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/collections.js